import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
    boxContainer:{
        width: '100%',
    }
}));
